
export function remplaceSoulignement(chaîne) {
    return chaîne.replace(/_/g, ' ');
}

export function ajusteNomClasse(classe) {
    let nom = remplaceSoulignement(classe);
    nom = nom.replace(/abrev/, 'abrév');
    return nom;
}

export function récupèreListeMEQ(étiquettes) {
    if (!étiquettes || étiquettes.length === 0) return "";
    let listeMEQ = "";
    let étiquetteComplète = étiquettes.find(étiquette => étiquette.startsWith("MEQ_LISTE_PRIMAIRE"))
    if (étiquetteComplète) {
        const num = étiquetteComplète[étiquetteComplète.length - 1 ];
        const sup = num === "1" ? "re" : "e";
        listeMEQ = `MEQ - ${num}<sup>${sup}</sup>`;
    }

    return listeMEQ;
}

export function récupèreValeurRO(ro) {
    if(ro && ro.trim().length > 0) {
        const typeRO = "Graphie recommandée par les rectifications de l’orthographe";
        return `<span class="rectangleSymboles-style infobulleDeclencheur" 
                      data-infobulle-id="rectification_orthographiqueRO" 
                      >
                    <span title="${typeRO}">RO</span>
                </span>`
    }

    return "";
}

export function ajusteNomGenre(genre) {
    let nom = genre;
    switch (genre) {
        case 'm' :
            nom = 'masculin';
            break;
        case 'f' :
            nom = 'féminin';
            break;
        case 'm_ou_f' :
            nom = 'masculin ou féminin';
            break;
        case 'f_ou_m' :
            nom = 'féminin ou masculin';
            break;
    }
    return nom;
}

export function ajusteNomNombre(nombre) {
    let nom = nombre;
    switch (nombre) {
        case 's' :
            nom = 'singulier';
            break;
        case 'p' :
            nom = 'pluriel';
            break;
        case 'inv' :
            nom = 'invariable';
            break;
    }
    return nom;
}

export function ajustePrononciations(prononciations, mot) {
    const iconeAudio = (window.beta === true)
        ? `<i class="usito-audio icon i-headphones" title="Écouter la prononciation du mot ${mot.graphie}" data-audio-ref="atome:${mot.id}" data-audio-origine="mots"></i>`
        : "";

    if (prononciations?.length > 0) {
        const apis = prononciations.map(p => p.trim()).join(', ');
        return `[${apis}] ${iconeAudio}`.trim();
    }

    return iconeAudio;
}

export function ajusteNomPersonne(personne) {
    let nom = personne;
    switch (personne) {
        case '1' :
            nom = '1<sup>ère</sup>';
            break;
        case '2' :
            nom = '2<sup>e</sup>';
            break;
        case '3' :
            nom = '3<sup>e</sup>';
            break;
    }
    return nom;
}
